var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("single-select-accessible", {
        attrs: {
          title: "SummaryReport.Collaboration.Partners.Partner",
          options: _vm.partnerTypeOptions,
          required: true,
          dropdownId: "partnerpartnertypes_" + _vm.index
        },
        model: {
          value: _vm.partner.type,
          callback: function($$v) {
            _vm.$set(_vm.partner, "type", $$v)
          },
          expression: "partner.type"
        }
      }),
      _vm._v(" "),
      _vm.partner.type !== _vm.PartnerType.Undefined &&
      _vm.partner.type != _vm.PartnerType.Organisation &&
      _vm.partner.type !== _vm.PartnerType.Other &&
      _vm.partner.type !== null
        ? _c("single-select-accessible", {
            key: _vm.descriptionKey,
            attrs: {
              title: _vm.getTitle(_vm.partner.type),
              options: _vm.getOptions(_vm.partner.type),
              required: true,
              value: { name: _vm.partner.name, id: _vm.partner.nameId },
              dropdownId: "partnername_" + _vm.index,
              doNotUseResources: true,
              optionOutput: true
            },
            on: {
              input: function($event) {
                _vm.partner.name = $event.name
                _vm.partner.nameId = $event.id
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.partner.type == _vm.PartnerType.Organisation
        ? _c("organisation-search-and-select", {
            attrs: {
              id: "organisationselect_" + _vm.index,
              index: _vm.index,
              options: _vm.organisations,
              required: true,
              title: _vm.getTitle(_vm.partner.type)
            },
            model: {
              value: _vm.selectedOrganisation,
              callback: function($$v) {
                _vm.selectedOrganisation = $$v
              },
              expression: "selectedOrganisation"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.partner.type === _vm.PartnerType.Other
        ? _c("text-area-row", {
            attrs: {
              title: _vm.getTitle(_vm.partner.type),
              id: "partnername_" + _vm.index,
              required: true,
              maxLength: 100,
              rows: 1,
              noResize: true
            },
            model: {
              value: _vm.partner.name,
              callback: function($$v) {
                _vm.$set(_vm.partner, "name", $$v)
              },
              expression: "partner.name"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cooperationTypeOptions
        ? _c("multiselect-row-accessible", {
            attrs: {
              title: "SummaryReport.Collaboration.Partners.CooperationTypes",
              options: _vm.cooperationTypeOptions,
              required: true,
              max: 3,
              dropdownId: "partnercooperationtypes_" + _vm.index
            },
            model: {
              value: _vm.partner.cooperationTypes,
              callback: function($$v) {
                _vm.$set(_vm.partner, "cooperationTypes", $$v)
              },
              expression: "partner.cooperationTypes"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isContinuousReport
        ? _c("text-area-row", {
            attrs: {
              title: "SummaryReport.Collaboration.Partners.Description",
              id: "partnerdescription_" + _vm.index,
              required: true,
              maxLength: 500,
              rows: 4,
              noResize: true
            },
            model: {
              value: _vm.partner.description,
              callback: function($$v) {
                _vm.$set(_vm.partner, "description", $$v)
              },
              expression: "partner.description"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }